module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.event.name) + "\n        "), (_vm.event.type === 'Class') ? _c('md-chip', {
    key: "evnetClass",
    staticClass: "md-primary"
  }, [_vm._v("クラス")]) : (_vm.event.type === 'Céilí') ? _c('md-chip', {
    key: "evnetCeili",
    staticClass: "md-accent"
  }, [_vm._v("ケーリー")]) : (_vm.event.type === 'SessionOrDance') ? _c('md-chip', {
    key: "evnetCeili",
    staticClass: "md-primary"
  }, [_vm._v("セッション/ダンス")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Hosted by " + _vm._s(_vm.event.host))])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n      " + _vm._s(_vm.getEventDate(_vm.event.startTime, _vm.event.endTime))), _c('br'), _vm._v("\n      @" + _vm._s(_vm.getHoursAndMinutes(_vm.event.startTime)) + "～" + _vm._s(_vm.getHoursAndMinutes(_vm.event.endTime))), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "textContent": _vm._s(_vm.event.description)
    }
  })]), _vm._v(" "), (_vm.event.url) ? _c('md-card-actions', {
    key: "externalLink"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary launchButton",
    attrs: {
      "href": _vm.event.url,
      "target": "_blank"
    }
  }, [_vm._v("詳細ページ "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("launch")])])], 1) : _vm._e(), _vm._v(" "), _c('md-subheader', [_vm._v("取り上げる予定のセット")]), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('md-list', [_vm._l((_vm.selectedSets), function(set, index) {
    return _c('md-list-item', {
      key: index,
      staticClass: "md-double-line"
    }, [_c('md-avatar', {
      staticClass: "md-large"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.allSets[set].figures[0].youtube ? _vm.getThumbnail(_vm.allSets[set].figures[0].youtube.url) : _vm.getThumbnail(_vm.allSets[set].thumbnail),
        "alt": "Thumbnail"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [(_vm.allSets[set].needsSet) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(set) + " Set\n            ")]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(set) + "\n            ")])], 1), _vm._v(" "), (set.needsSet) ? _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n            " + _vm._s(_vm.allSets[set].jpCaption) + "・セット\n          ")]) : _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n            " + _vm._s(_vm.allSets[set].jpCaption) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.getDescription(_vm.allSets[set])) + "\n          ")])]), _vm._v(" "), _c('md-divider')], 1)
  }), _vm._v(" "), (_vm.event.lastSong === 'anthem') ? _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-large"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SoldiersSong'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ireland.gif",
      "alt": "Thumbnail"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'SoldiersSong'
      }
    }
  }, [_vm._v("\n              Amhrán na bhFiann\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "jpCaption"
  }, [_vm._v("\n            兵士の歌\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            March - March - March\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.event.lastSong === 'shinano') ? _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-large"
  }), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Shinano'
      }
    }
  }, [_vm._v("\n              信濃の国\n            ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "jpCaption"
  }, [_vm._v("\n            Shinano-no-kuni\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            March - March - March - March - March - March\n          ")])])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "event-controller"
  }, [_c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'EditEvent',
        params: {
          eventId: _vm.eventId
        }
      }
    }
  }, [_vm._v("イベントを編集する")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.openDialog('editSetsDialog')
      }
    }
  }, [_vm._v("セットを編集する")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("イベントはどなたでも編集することができます。イベントで扱われるセットをご存じでしたら登録していただけると幸いです。掲載内容にもし不都合がありましたら城までご連絡ください。")])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteEventDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("イベントを削除します")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      この操作は取り消せません。" + _vm._s(_vm.event.name) + "を削除しますか？\n\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.cancelDialog('deleteEventDialog')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteEvent('deleteEventDialog')
      }
    }
  }, [_vm._v("削除する")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "editSetsDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": false,
      "md-esc-to-close": false
    }
  }, [_c('md-dialog-title', [_vm._v("取り上げる予定のセット")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      チェックの付いたセットがイベントページに表示されます。\n      "), _c('md-list', _vm._l((_vm.allSets), function(set, index) {
    return _c('md-list-item', {
      key: index,
      staticClass: "md-double-line"
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "id": 'checkbox' + index,
        "name": "my-test10",
        "md-value": set.name
      },
      model: {
        value: (_vm.selectedSets),
        callback: function($$v) {
          _vm.selectedSets = $$v
        },
        expression: "selectedSets"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "md-list-text-container"
    }, [(set.needsSet) ? _c('span', [_vm._v("\n              " + _vm._s(set.name) + " Set\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(set.name) + "\n            ")]), _vm._v(" "), (set.needsSet) ? _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n              " + _vm._s(set.jpCaption) + "・セット\n            ")]) : _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n              " + _vm._s(set.jpCaption) + "\n            ")])]), _vm._v(" "), _c('md-divider')], 1)
  }))], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.cancelEditSetsDialog('editSetsDialog')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.addSets('editSetsDialog')
      }
    }
  }, [_vm._v("変更する")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566e149f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event.vue
// module id = 334
// module chunks = 1